import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import { SvgIcon } from 'helpers/SvgIcon';
import { createLinkField } from 'lib/utils/navigation-utils';
import { contextualNavTailwindVariants } from './ContextualNav';
import { getTestProps } from 'lib/testing/utils';
export const ContextualNavItem = ({ item, isCurrent, isExpanded, hasChildren, onToggle, level = 1, showToggle = true, isNavExpanded = true, isParentExpanded = true, className = '' })=>{
    const showLevelToggle = hasChildren && showToggle;
    const isTabbable = isNavExpanded && isParentExpanded;
    const { navItem, link, button, icon, childIcon } = contextualNavTailwindVariants({
        current: isCurrent,
        isExpanded,
        isTopLevel: level == 1,
        isChild: level > 1,
        isChildNoToggle: level > 1 && !hasChildren,
        isLevel2: level == 2,
        level2isExpanded: level == 2 && isExpanded,
        isLevel3: level == 3
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: `${navItem()} ${className}`,
        ...getTestProps(`component-contextual-nav-item`),
        children: [
            /*#__PURE__*/ _jsx(LinkWrapper, {
                className: link(),
                field: createLinkField(item),
                "aria-current": isCurrent ? 'page' : undefined,
                ctaComponentClass: "default",
                tabIndex: !isTabbable ? -1 : undefined,
                ...getTestProps(`page-link`)
            }),
            showLevelToggle ? /*#__PURE__*/ _jsx("button", {
                className: button(),
                "aria-expanded": isExpanded,
                "aria-controls": `contextual-nav-sublist-${item.id}`,
                "aria-label": isExpanded ? 'Collapse section' : 'Expand section',
                onClick: ()=>onToggle(item.id),
                type: "button",
                tabIndex: !isTabbable ? -1 : undefined,
                children: /*#__PURE__*/ _jsx(SvgIcon, {
                    className: icon(),
                    icon: "chevron-down",
                    size: "xs"
                })
            }) : /*#__PURE__*/ _jsx(SvgIcon, {
                className: childIcon(),
                icon: "arrow-dash-right",
                size: "xs"
            })
        ]
    });
};
